import React from "react";
import ReactGA from "react-ga";

const useAnalyticsEventTracker = (category="users Info") => {
  const eventTracker = (action = "action", label = "user clicked") => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}
export default useAnalyticsEventTracker;